import { getCookieValue } from "@src/utils/cookieHelper";
import { ILocaleCreatorInput, TLocale, TMessages } from "../i18n";
import { defaultRichTextElements } from "./defaultRichTextElements";
import { getParameterByName } from "@src/utils/queryHandler";
import { getLocalFromPath } from "@src/utils/getLocalFromPath";
const globedMessages = import.meta.glob<true, string, TMessages>(
  "../../l10n/autoDebit/*.json",
  { import: "default", eager: true }
);

function locale(): TLocale {
  const pathLocal = getLocalFromPath("autodebit");
  let locale = getParameterByName("language");
  if (
    !locale &&
    (location.pathname.includes("/nst/") ||
      location.pathname.includes("/aplus/"))
  ) {
    // only result page get locale from cookie
    locale = getCookieValue("language_at_login");
  }

  if (!locale) {
    // register page get local from document(VHM page)
    locale = document.documentElement.lang;
  }

  const defaultLang = "ja";
  return pathLocal ?? (locale as TLocale) ?? defaultLang;
}

function localeCreatorInput(): ILocaleCreatorInput {
  return {
    locale: locale(),
    globedMessages,
    defaultRichTextElements,
  };
}

export { localeCreatorInput };
